// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../ASSETS/BACKGROUND/NoiseBg.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactForm {
  color: #aab5b7;
  margin-bottom: 0.5em;
  padding: 20px 0 10px; /* Optional: add padding to the container */
  border-radius: 10px; /* Optional: add border radius for rounded corners */

}

.contactForm .form-control {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); 
  background-size: cover; /* Ensure the image covers the entire container */
  background-repeat: no-repeat; /* Prevent the image from repeating */
  background-color: transparent; /* Make the background transparent */
  color: white;
  line-height: 2em;
  width: 90%;
  /* margin-left: -50px; */
  margin-top: 1px;
}

.contactForm .form-control:focus {
  color: white;
  background-color: transparent; /* Keep the background transparent on focus */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Set background image here */
  background-size: cover; /* Ensure the image covers the entire container */
  background-repeat: no-repeat; /* Prevent the image from repeating */
}

.contactForm .form-control::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.contactForm .text-danger {
  color: #aab5b7 !important;
}

.formSubmit {
  padding-left: 5em;
  padding-right: 5em;
  background-color: rgb(79, 81, 79) !important;
  border-color: rgb(79, 81, 79) !important;
  border-radius: 2em;
  margin: 2px;
  margin-left: -40px;
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/FORM/CONTACT/index.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;EACpB,oBAAoB,EAAE,2CAA2C;EACjE,mBAAmB,EAAE,oDAAoD;;AAE3E;;AAEA;EACE,yDAAgE;EAChE,sBAAsB,EAAE,iDAAiD;EACzE,4BAA4B,EAAE,qCAAqC;EACnE,6BAA6B,EAAE,oCAAoC;EACnE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6BAA6B,EAAE,6CAA6C;EAC5E,yDAAgE,EAAE,8BAA8B;EAChG,sBAAsB,EAAE,iDAAiD;EACzE,4BAA4B,EAAE,qCAAqC;AACrE;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;EAC5C,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".contactForm {\n  color: #aab5b7;\n  margin-bottom: 0.5em;\n  padding: 20px 0 10px; /* Optional: add padding to the container */\n  border-radius: 10px; /* Optional: add border radius for rounded corners */\n\n}\n\n.contactForm .form-control {\n  background-image: url(\"../../../ASSETS/BACKGROUND/NoiseBg.webp\"); \n  background-size: cover; /* Ensure the image covers the entire container */\n  background-repeat: no-repeat; /* Prevent the image from repeating */\n  background-color: transparent; /* Make the background transparent */\n  color: white;\n  line-height: 2em;\n  width: 90%;\n  /* margin-left: -50px; */\n  margin-top: 1px;\n}\n\n.contactForm .form-control:focus {\n  color: white;\n  background-color: transparent; /* Keep the background transparent on focus */\n  background-image: url(\"../../../ASSETS/BACKGROUND/NoiseBg.webp\"); /* Set background image here */\n  background-size: cover; /* Ensure the image covers the entire container */\n  background-repeat: no-repeat; /* Prevent the image from repeating */\n}\n\n.contactForm .form-control::placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.contactForm .text-danger {\n  color: #aab5b7 !important;\n}\n\n.formSubmit {\n  padding-left: 5em;\n  padding-right: 5em;\n  background-color: rgb(79, 81, 79) !important;\n  border-color: rgb(79, 81, 79) !important;\n  border-radius: 2em;\n  margin: 2px;\n  margin-left: -40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
